module.exports = __webpack_public_path__ + "static/media/ATC.b28f9eca.png";